import React, { useEffect, useState } from "react";
import "./Banner.css";

interface BannerProps {
    messages: string[];
    autoHideTime?: number; // milliseconds
    onClose: () => void;
}

const Banner: React.FC<BannerProps> = ({ messages, autoHideTime = 4000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [index, setIndex] = useState(0);

    // Rotate messages
    useEffect(() => {
        const rotate = setInterval(() => {
            setIndex((prev) => (prev + 1) % messages.length);
        }, 3000);

        return () => clearInterval(rotate);
    }, [messages]);

    // Auto-hide
    // If it's value is 0 then do not auto hide
    useEffect(() => {
        if (autoHideTime !== 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                onClose();
            },
                autoHideTime);
            return () => clearTimeout(timer);
        }
    }, [autoHideTime]);

    const onBannerClose = (visibility: boolean) => {
        setIsVisible(visibility);
        onClose();
    }

    if (!isVisible) return null;

    return (
        <div className="custom-banner banner-slide-down">
            <p className="banner-content"
                dangerouslySetInnerHTML={{ __html: messages[index] }}
            ></p>

            <button className="close-btn" onClick={() => onBannerClose(false)}>
                ✕
            </button>
        </div>
    );
};

export default Banner;
